//api接口统一管理
import { get, post } from './http'
//线上
// let Frontdrop = '/server'
//本地
let Frontdrop = "/api";
// let Frontdrop = "";
// 登陆
//押金预存患者信息
export const cashPrestore = p => post(Frontdrop + '/business/inpatPatinfos/getInhosptialinfo', p)
//门诊缴费list获取
export const simulationList = p => post(Frontdrop + '/business/outpatPaycost/simulationList', p)
//微信支付
export const createPayOrder = p => post(Frontdrop + '/weChatPay/createPayOrder', p)
//门诊微信支付
export const addOutpatPaycost = p => post(Frontdrop + '/business/outpatPaycost/addOutpatPaycost', p)
// 门诊已缴费记录
export const paidList = p => post(Frontdrop + '/business/outpatPaycost/paidList', p)
// 预存微信支付
export const addHospitalDeposit = p => post(Frontdrop + '/business/inpatDepositlist/addHospitalDeposit', p)
// 预存记录
export const getHospitalDepositList = p => post(Frontdrop + '/business/inpatDepositlist/getHospitalDepositList', p)
//就医问卷
export const getQuestions = p => post(Frontdrop + '/business/qQuestionnaires/getQuestionnaire', p)
//问卷提交
export const submitQuestionnaire = p => post(Frontdrop + '/business/qResultsinfo/submitQuestionnaire', p)
// 清单
export const InpatientDaysList = p => post(Frontdrop + '/business/inpatPatinfos/InpatientDaysList', p)
// 门诊清单
export const simulationListMen = p => post(Frontdrop + '/business/outpatFeesinfo/simulationList', p)
//获取检查报告
export const getCheckUpReportResults = p => post(Frontdrop + '/business/InspectionReport/getCheckUpReportResults', p)
//获取检验报告
export const getInspectionReportResults = p => post(Frontdrop + '/business/InspectionReport/getInspectionReportResults', p)
//获取微站主页菜单
export const getbWebmenu = p => post(Frontdrop + '/business/bWebmenu/getbWebmenu', p)
//医院简介
export const hspCode = hspCode => post(Frontdrop + `/business/hosptialintroduce/getHosptialIntroduce/${hspCode}`, hspCode)
//医院楼栋信息
export const getBuildinginfo = hspCode => post(Frontdrop + `/business/bBuildinginfo/getBuildinginfo/${hspCode}`, hspCode)
// 医生列表
export const getDoctorList = deptCode => get(Frontdrop + `/business/uUsers/getDoctorList/${deptCode}`)
// 医生列表
export const getDoctorList1 = p => post(Frontdrop + `/business/outpatRegistinfo/listDoctor`, p)
//缴费状态详情
export const getPaidInfo = tradeId => post(Frontdrop + `/business/outpatPaycost/getPaid/${tradeId}`, tradeId)
//根据流水号预存
export const getHospitalDepositListInfo = tradeId => get(Frontdrop + `/business/inpatDepositlist/getHospitalDepositList/${tradeId}`)
//百度地图导航
// export const weChatLogin = url => get(Frontdrop+`/weChatLogin/getConfigData`)
export const weChatLogin = url => get(Frontdrop + `/weChatLogin/getConfigData?url=${url}`)
// 科室列表
export const getBDeptinfo = p => post(Frontdrop + '/business/bDeptinfo/getBDeptinfo', p)
//健康宣教
export const getNHealtheducation = p => post(Frontdrop + '/business/nHealtheducation/getNHealtheducation', p)
//list
export const list = p => post(Frontdrop + '/business/outpatRegistinfo/list', p)
//查询用户列表
export const CardListInfo = p => post(Frontdrop + '/business/sysRealuserinfo/getRealuserinfo', p)
//添加病人||绑卡(成人或者儿童)
export const AddPatient = p => post(Frontdrop + '/business/sysRealuserinfo/addsysRealuserinfo', p)
//某人所有的卡
export const card = p => get(Frontdrop + `/business/sysRealuserinfo/removeRealuserinfo/${p}`, p)
//条形码和二维码
export const BarCode = p => get(Frontdrop + `/business/sysUsercardinfo/getBarCode/${p}`, p)
//设置默认卡
export const Seting = p => post(Frontdrop + '/business/sysUsercardinfo/setDefaultCard', p)
//医生列表
export const DocterList = p => post(Frontdrop + '/business/outpatRegistinfo/listDoctor', p)
//获取排班信息
export const getDocterClass = p => post(Frontdrop + '/business/outpatRegistinfo/listRegistinfo', p)
//预约挂号支付接口
export const AppoinitPay = p => post(Frontdrop + '/business/outpatRegistinfo/registrationPayment', p)
//解绑卡
export const CloseCard = p => get(Frontdrop + `/business/sysUsercardinfo/unBundlingCard/${p}`, p)
//设置默认卡
export const SettingCard = p => get(Frontdrop + `/business/sysUserregistration/setDefaultCard/${p}`, p)
//获取卡信息
export const CardInfo = p => get(Frontdrop + `/business/sysUsercardinfo/getUsercardinfo/${p}`, p)
//获取新闻动态
export const NewsInfo = p => post(Frontdrop + `/business/news/getNews`, p)
//获取候诊信息
export const getWaitingInfo = p => get(Frontdrop + `/business/outpatRegistinfo/waitingReminder/${p}`, p)
//获取检查信息
export const getCheckInfo = p => get(Frontdrop + `/business/outpatPaycost/checkReminder/${p}`, p)
//获取取药信息
export const getTalesInfo = p => get(Frontdrop + `/business/outpatPaycost/waitingReminder/${p}`, p)
//获取用户信息
export const getUserInfo = p => get(Frontdrop + `/business/sysUserregistration/getUserregistration`, p)
//挂号详情
export const getHosiptalInfo = p => get(Frontdrop + `/business/outpatRegistinfo/getRegistrationByTradeId/${p}`, p)
//搜索医生
export const searchDoctor = p => get(Frontdrop+`/business/uUsers/getDoctor`,p)
//获取身体部位
export const getBody = p => post(Frontdrop + `/business/bodySymptom/showBody`,p)
//获取身体病症
export const getSymptom = p => get(Frontdrop + `/business/bodySymptom/showSymptom/${p}`, p)
//获取疾病与科室
export const getDisease = p => post(Frontdrop + `/business/bodySymptom/showDisease`, p)


// 智能导诊
export const showBodyTwo = p => post(Frontdrop + `/business/bodySymptom/showBodyTwo`, p)  //智能导诊-症状列表（全部）
export const showSymptom = p => post(Frontdrop + `/business/bodySymptom/showSymptom`, p)  //智能导诊-症状列表（性比，部位）


export const selectVisitinfos = p => post(Frontdrop + `/biz/bVisitinfo/selectVisitinfos`, p) // 查询所有的卡
export const insert = p => post(Frontdrop + `/biz/bVisitinfo/insert`, p) // 建档无就诊卡
export const bind = p => post(Frontdrop + `/biz/bVisitinfo/bind`, p) // 建档有就诊卡
export const getItmPage = p => post(Frontdrop + `/biz/userOpen/getItmPage`, p) // 信息推送
export const setStyle = p => post(Frontdrop + `/biz/bVisitinfo/setStyle`, p) // 设置默认卡
export const delCard = p => get(Frontdrop + `/biz/bVisitinfo/del/${p}`, p) // 删除就诊卡
export const selectBHosptialinfo = p => post(Frontdrop + `/business/bHosptialinfo/selectBHosptialinfo`, p) // 查询所有院区的基本信息
export const selectBuilding = p => post(Frontdrop + `/business/bHosptialinfo/selectBuilding`, p) // 查询楼层信息
export const selectBDeptinfo = p => post(Frontdrop + `/business/bHosptialinfo/selectBDeptinfo`, p) // 查询所有科室
export const selectBDoctorinfo = p => post(Frontdrop + `/business/bHosptialinfo/selectBDoctorinfo`, p) // 查询所有的专家
export const getConfigData = url => get(Frontdrop + `/wx/weChatUser/getConfigData?url=${url}`) // 获取JS-SDK信息
export const getIpPatient = p => post(Frontdrop + `/biz/Hospitalization/getIpPatient`, p) // 住院信息查询
export const getIpPatBillAll = p => post(Frontdrop + `/biz/Hospitalization/getIpPatBillAll`, p) // 总清单
export const getIpPatientBill = p => post(Frontdrop + `/biz/Hospitalization/getIpPatientBill`, p) // 日清单
export const getInDepositView = p => post(Frontdrop + `/biz/Hospitalization/getInDepositView`, p) // 住院充值记录查询
export const getItemPrices = p => post(Frontdrop + `/biz/QueryPrinting/getItemPrices`, p) // 物价查询
export const getRegDate = p => post(Frontdrop + `/biz/bRegistinfo/getRegDate`, p) // 获取可挂号日期
export const getRegLocation = p => post(Frontdrop + `/biz/bRegistinfo/getRegLocation`, p) // 科室查询
export const getOuDeptSchedules = p => post(Frontdrop + `/biz/bRegistinfo/getOuDeptSchedules`, p) // 医生排班
export const getDoctorScheduleTime = p => post(Frontdrop + `/biz/bRegistinfo/getDoctorScheduleTime`, p) // 可挂号时间段
export const LockRegOrder = p => post(Frontdrop + `/biz/bRegistinfo/LockRegOrder`, p) // 锁号
export const payRegOrder = p => post(Frontdrop + `/biz/bRegistinfo/payRegOrder`, p) // 支付确认
export const getRegRecord = p => post(Frontdrop + `/biz/bRegistinfo/getRegRecord`, p) // 预约记录查询
export const getRefRecord = p => post(Frontdrop + `/biz/bRegistinfo/getRefRecord`, p) // 查询患者三天内的挂号记录信息
export const getRegRecordDetail = p => post(Frontdrop + `/biz/bRegistinfo/getRegRecordDetail?lockid=${p}`) // 预约记录详情查询
export const CancelLockRegOrder = p => post(Frontdrop + `/biz/bRegistinfo/CancelLockRegOrder`, p) // 取消锁号
export const getSatisfactionsSurvey = p => post(Frontdrop + `/biz/qQuestionnaires/getSatisfactionsSurvey?questionnaireId=${p}`) // 获取问卷
export const fillSatisfactionsSurvey = p => post(Frontdrop + `/biz/qQuestionnaires/fillSatisfactionsSurvey`, p) // 提交问卷
export const GetPaymentOpChargeDtl = p => post(Frontdrop + `/biz/Outpatient/GetPaymentOpChargeDtl`, p) // 待缴费查询
export const getPayedRecipe = p => post(Frontdrop + `/biz/Outpatient/getPayedRecipe`, p) // 门诊费用记录查询
export const getPayedRecipeDtl = p => post(Frontdrop + `/biz/Outpatient/getPayedRecipeDtl`, p) // 门诊费用详情查询
export const appointmentCountDown = p => post(Frontdrop + `/biz/bRegistinfo/appointmentCountDown?lockid=${p}`) // 订单倒计时
export const getCkLabResult = p => post(Frontdrop + `/biz/QueryPrinting/getCkLabResult`, p) // 报告单查询
export const GetCkLabDtlResult = p => post(Frontdrop + `/biz/QueryPrinting/GetCkLabDtlResult`, p) // 报告单详情查询
export const pay = p => post(Frontdrop + `/abc/pay`, p) // 调起农业银行预支付
export const getPapers = p => post(Frontdrop + `/biz/qQuestionnaires/getPapers`, p) // 获取问卷列表

export const GetHosptal = p => post(Frontdrop + `/business/bHosptialinfo/GetHosptal`, p) // 查询所有院区的基本信息
export const Authorization = p => post(Frontdrop + `/biz/GetHealthRecordsAccredit/Authorization`, p) // 健康档案调阅授权




// WEBPACK FOOTER //
// ./src/request/api.js